import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../themeContext";

import axios from "axios";

import Boitebox from "./Boitebox";

import ReactPaginate from "react-paginate";
import { makeStyles } from "@material-ui/core/styles";
import ScaleLoader from "react-spinners/ScaleLoader";

import { useTranslation, withTranslation } from "react-i18next";

//import Boitebox from"./Boitebox"

function Boitevocale() {
  const { t } = useTranslation("common");

  const [croix, setcroix] = useState(false);
  const [state, dispatch] = useContext(Context);

  function test() {
    setSearchText("");
    getAllcollegues();

    setcroix(true);
  }
  const token = localStorage.getItem("AccessToken");
  const compte = localStorage.getItem("compte");
  const poste = localStorage.getItem("poste");
  const BackendURL = window.BackendURLCmk;
  const tabcol2 = localStorage.getItem("tabcollegue");
  const tabcol = JSON.parse(tabcol2);
  const tabcontact2 = localStorage.getItem("tabcontact");
  const tabcontact = JSON.parse(tabcontact2);
  const useStyles = makeStyles((theme) => ({
    switch_track: {
      backgroundColor: "#D3D3D3",
    },
    switch_base: {
      color: "#95cc97",
      "&.Mui-disabled": {
        color: "#D3D3D3",
      },
      "&.Mui-checked": {
        color: "#95cc97",
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#4CAF50",
      },
    },
    switch_primary: {
      "&.Mui-checked": {
        color: "#D3D3D3",
      },
      "&.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#D3D3D3",
      },
    },
  }));
  const classes = useStyles();
  const [collgchoice, setcollgchoice] = useState("all");

  const [black1, changeColor1] = useState(
    "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4 dark:text-white  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black2, changeColor2] = useState(
    "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white  border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black3, changeColor3] = useState(
    "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  const [black4, changeColor4] = useState(
    "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
  );
  function handleOrangeClick() {
    // Similar to this.setState({ fruit: 'orange' })

    changeColor1(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    // getAllcolleguesnonlu();
    setcollgchoice("nonlu");

    setOffset(1);
    //ActiveColor("text-gray-700");
  }

  function handleOrangeClick3() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })

    changeColor3(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  pr-4 border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    //getAllcollegueslu();
    setcollgchoice("lu");

    setOffset(1);
    //ActiveColor("text-gray-700");
  }
  function handleOrangeClick4() {
    //ActiveColor("text-gray-700");
    // Similar to this.setState({ fruit: 'orange' })

    changeColor4(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4   border-green-500 text-green-600 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor3(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor2(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    changeColor1(
      "mr-2 pr-1 md:mr-4 md:pr-2 lg:mr-8 lg:pr-4  dark:text-white border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
    );
    //getAllcollegues();
    setcollgchoice("all");

    setOffset(1);
    //ActiveColor("text-gray-700");
  }
  const [swich, setSwich] = React.useState({
    checkedA: true,
  });
  //const handleSwich = () => setSwich(true);
  // const handleChange2 = (name) => (event) => {
  //   setSwich({ ...swich, [name]: event.target.checked });
  //   if (swich.checkedA == false) {
  //     getAllcolleguesnonlu();
  //   } else {
  //     getAllcollegues();
  //   }
  // };
  // const [boites, setBoite] = useState([]);
  const [collegues2, setAllcollegues2] = useState([]);
  const [colleguesPerPage] = useState(30);
  const [offset, setOffset] = useState(1);
  const [collegues, setAllcollegues] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [collguesforpagination, setPageCollegues] = useState([]);
  const [loading, setloading] = useState("false");
  const length = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {offset * colleguesPerPage}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const length2 = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {collguesforpagination.length}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  let countforpagination =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    offset * colleguesPerPage +
    "  sur  " +
    collguesforpagination.length;

  let countforpagination2 =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    collguesforpagination.length +
    "  sur  " +
    collguesforpagination.length;
  const fetchmsgvocal = () => {
    var lien = window.location.href;
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const res = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=nouveau`,
        config
      )
      .then((res) => {
        const data2 = res.data.log_voicemail.reverse();
        var data3 = res.data.log_voicemail.length;
        dispatch({ type: "MSG_vocaux", payload: data3 });
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const getAllcollegues = async () => {
    if (collgchoice === "all") {
      setloading(true);
      var lien = window.location.href;
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const res = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=`,
          config
        )
        .then((res) => {
          const data = res.data.log_voicemail.reverse();
          // console.log("this is consulter", data2);
          //let data = data2.filter((el) => el.poste !== poste);
          setAllcollegues2(data);
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (collgchoice === "nonlu") {
      setloading(true);
      var lien = window.location.href;
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const res = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=nouveau`,
          config
        )
        .then((res) => {
          const data2 = res.data.log_voicemail.reverse();
          var data3 = res.data.log_voicemail.length;
          dispatch({ type: "MSG_vocaux", payload: data3 });

          let data = data2.filter((el) => el.poste !== poste);
          setAllcollegues2(data2);
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
    if (collgchoice === "lu") {
      setloading(true);
      var lien = window.location.href;
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const res = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=consulter`,
          config
        )
        .then((res) => {
          const data2 = res.data.log_voicemail.reverse();

          let data = data2.filter((el) => el.poste !== poste);
          setAllcollegues2(data2);
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };
  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setOffset(selectedPage + 1);
  };

  const [searchText, setSearchText] = useState("");
  const colleguenewarray = () => {
    for (var i = 0; i < collegues2.length; i++) {
      Object.keys(collegues2[i]).forEach(function (key) {
        if (collegues2[i][key] == null) {
          //  console.log("thiiiiiiiiis", collegues2[i][key]);
          collegues2[i][key] = "-";
        }
      });
    }
  };
  const excludeColumns = [
    "boite",
    "callerchan",
    "category",
    "chemain_fichier_audio",
    "context",
    "etat",
    "exten",
    "clid",
    "fichier",
    "flag",
    "id",
    "id_appel",
    "msg_id",
    "macrocontext",
    "msg_id",
    "msg_text",
    "nouveau_chamain",
    "origmailbox",
    "origdate",
    "origmailbox",
    "origtime",
    "priority",
  ];
  const filterData = (value) => {
    //  handleresearchui();
    // handleOrangeClick4();
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") setAllcollegues(collegues);
    else {
      // console.log("this collegue without null");
      colleguenewarray();
      const filteredData = collegues2.filter((item) => {
        return Object.keys(item).some((key) =>
          excludeColumns.includes(key)
            ? false
            : item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });
      // setAllcollegues(filteredData);
      setPageCollegues(filteredData);
      setOffset(1);
      const slice = filteredData.slice(
        (offset - 1) * colleguesPerPage,
        offset * colleguesPerPage
      );
      //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
      //console.log(slice);

      // For displaying Data
      const postData = getPostData(slice);

      // Using Hooks to set value
      setAllcollegues(postData);
      setPageCount(Math.ceil(filteredData.length / colleguesPerPage));
      //getPostData(filteredData);
    }
  };

  const handleChange = (value) => {
    //console.log("this is value of research ", value);
    setSearchText(value);
    filterData(value);
  };

  const getPostData = (data) => {
    return data.map((post) => (
      <Boitebox
        boite={post}
        tabcontact={tabcontact}
        tabcol={tabcol}
        toggle={toggleShowHide}
        fetchmsgvocal={fetchmsgvocal}
      />
    ));
  };

  //const [showtogglet, settoggleshow] = useState("");

  const toggleShowHide = () => {
    if (collgchoice === "all") {
      setloading(true);
      var lien = window.location.href;
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const res = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=`,
          config
        )
        .then((res) => {
          const data = res.data.log_voicemail.reverse();

          // console.log("this is consulter", data2);
          //let data = data2.filter((el) => el.poste !== poste);
          setAllcollegues2(data);
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }

    if (collgchoice === "nonlu") {
      setloading(true);
      var lien = window.location.href;
      const var2 = lien.split("/");
      //console.log("kien ici", var2[2]);
      var var4 = var2[2].split(":");
      // console.log("kien ici", var4[0]);
      var config = {
        headers: {
          Authorization: token,
        },
      };
      const res = axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/MessagesVocauxIPBXV3API?compte=${compte}&poste=${poste}&date_debut=&date_fin=&filtre=nouveau`,
          config
        )
        .then((res) => {
          const data2 = res.data.log_voicemail.reverse();
          let data = data2.filter((el) => el.poste !== poste);
          var data3 = res.data.log_voicemail.length;
          dispatch({ type: "MSG_vocaux", payload: data3 });
          setAllcollegues2(data2);
          setPageCollegues(data);
          const slice = data.slice(
            (offset - 1) * colleguesPerPage,
            offset * colleguesPerPage
          );

          // For displaying Data
          const postData = getPostData(slice);

          // Using Hooks to set value
          setAllcollegues(postData);
          setPageCount(Math.ceil(data.length / colleguesPerPage));
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    }
  };
  useEffect(() => {
    getAllcollegues();

    //getAllcolleguesnonlu();
  }, [collgchoice, offset]);
  if (loading == false) {
    return (
      <div className="content pb-4 px-2 flex flex-col h-screen">
        {/* <main className="flex-1 relative overflow-y-auto focus:outline-none"> */}
        {/* {console.log(collegues)} */}
        <div className="py-6">
          <div class="md:flex md:items-center md:justify-between mb-8 mx-4">
            <div class="flex-1 min-w-1">
              <div className="flex">
                <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                  {t("voicemailmessages")}
                  {/* <span className="text-gray-600 text-sm rounded-xl bg-gray-100 ml-2 -mt-16 px-2 py-1">
                    <span>{collguesforpagination.length}</span>
                  </span> */}
                </h2>
              </div>
            </div>

            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                className="dark:bg-gray-600  focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("trouvervoicemail")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />{" "}
              <div class="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              {searchText != "" ? (
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center dark:text-gray-100 transition-al hover:bg-gray-100"
                  onClick={() => {
                    test();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              ) : (
                <div></div>
              )}
            </div>

            {/* <SearchBox handleInput={handleInput} /> */}
          </div>
          <div className="dark:border-gray-800 border-b border-gray-200 dark:text-white transition-al">
            {collguesforpagination.length !== 0 ? (
              <div className="flex h-6">
                <div
                  className="flex"
                  style={{ marginLeft: "auto", order: "2" }}
                >
                  <span className="text-gray-500 dark:text-white">
                    {offset == pageCount ? length2() : length()}
                  </span>

                  {/* <span>{countforpagination}</span> */}

                  <ReactPaginate
                    previousLabel={"<"}
                    previousClassName={
                      "dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    nextLabel={">"}
                    nextClassName={
                      "pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    breakLabel={"countforpagination"}
                    breakClassName={"hidden"}
                    pageClassName={
                      "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                    }
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "relative z-0 inline-flex rounded-md  -space-x-px"
                    }
                    activeClassName=""
                    forcePage={offset - 2}
                  />
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <nav className="flex-1 min-w-2 " aria-label="Tabs">
              <a
                href="#"
                className={black4}
                onClick={() => handleOrangeClick4()}
              >
                {/* <Voicemail
                  className="text-gray-500 group-hover:text-gray-500
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}

                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("all.voicemail.messages")}
                </span>
                <span className="lg:hidden md:hidden">{t("all.media")}</span>
              </a>

              <a
                href="#"
                className={black1}
                onClick={() => handleOrangeClick()}
              >
                {/* <Voicemail
                  className="text-gray-500 group-hover:text-gray-500
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}

                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("new.voicemail")}
                </span>
                <span className="lg:hidden md:hidden">
                  {" "}
                  {t("new.voicemail.media")}
                </span>
              </a>

              <a
                href="#"
                className={black3}
                aria-current="page"
                onClick={() => handleOrangeClick3()}
              >
                {/* <Voicemail
                  className="text-gray-500 group-hover:text-gray-500
                    mr-1 h-5 w-5"
                  aria-hidden="true"
                /> */}
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("viewedvoicemail")}
                </span>
                <span className="lg:hidden md:hidden">{t("consulte")}</span>
              </a>
            </nav>
          </div>
        </div>
        {collguesforpagination.length !== 0 ? (
          <div className="overflow-y-auto grid grid-cols-1 gap-4 lg:grid-cols-3 sm:grid-cols-1 md:grid-cols-2 mt-4">
            {/* Replace with your content */}
            {/* {console.log(collegues[1].nom)} */}

            {collegues}
          </div>
        ) : (
          <div className="justify-center mt-64  p-0 self-center">
            <h2 className=" dark:text-white text-lg font-medium   sm:text-3xl sm:truncate text-gray-400">
              {t("novoicemails")}{" "}
            </h2>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="content pb-20 px-2">
        <div className="py-6">
          <div class="md:flex md:items-center md:justify-between mb-8 mx-4">
            <div class="flex-1 min-w-1">
              <div className="flex">
                <h2 className=" dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                  {t("voicemailmessages")}
                </h2>
              </div>
            </div>
            <div className="flex row-span-1 h-6"></div>
            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="text"
                className="dark:bg-gray-600  focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                placeholder={t("trouvervoicemail")}
                value={searchText}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                  webKitBoxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  boxShadow:
                    " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                }}
              />{" "}
              <div class="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
          </div>
          {/* <div className=" border-b border-gray-200 dark:border-gray-800 flex">
            <nav className="flex-1 min-w-2 " aria-label="Tabs">
              <a
                href="#"
                className={black4}
                onClick={() => handleOrangeClick4()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("all.voicemail.messages")}
                </span>
                <span className="lg:hidden md:hidden">{t("all.media")}</span>
              </a>

              <a
                href="#"
                className={black1}
                onClick={() => handleOrangeClick()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("new.voicemail")}
                </span>
                <span className="lg:hidden md:hidden">
                  {t("new.voicemail.media")}
                </span>
              </a>

              <a
                href="#"
                className={black3}
                aria-current="page"
                onClick={() => handleOrangeClick3()}
              >
                <span className="hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                  {t("viewedvoicemail")}
                </span>
                <span className="lg:hidden md:hidden">{t("consulte")}</span>
              </a>
            </nav>
          </div> */}
          <div className="flex flex-wrap justify-center mt-64">
            <ScaleLoader
              color="#109669"
              loading={loading}
              size={50}
              width={4}
              height={68}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation("common")(Boitevocale);
